import * as SidebarLink from 'components/sidebar/SidebarLink';
import { IntercomProductTourTargets } from 'constants/intercom';
import { TestIds } from 'constants/tests';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const PaymentsLinks = () => {
    const { access, accountId } = useCurrentAccount();
    const linkPath = `/accounts/${accountId}/transactions`;
    const navLinks = [
        linkPath,
        `/accounts/${accountId}/tickets`,
        `/accounts/${accountId}/plans`,
        `/accounts/${accountId}/pledges`,
    ];

    if (!access.pages.includes('transactions')) return null;

    return (
        <SidebarLink.Link
            to={linkPath}
            data-testid={TestIds.Sidebar.TransactionsLink}
            data-intercom-target={IntercomProductTourTargets.SidebarTransactionsLink}
        >
            <SidebarLink.LevelOne
                icon="receipt"
                isActive={navLinks.some(link => location.pathname.includes(link))}
            >
                Transactions
            </SidebarLink.LevelOne>
        </SidebarLink.Link>
    );
};

export { PaymentsLinks };
